import React from "react";
import TextField from "@material-ui/core/TextField";
import { Select, MenuItem } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import FormTemplate from "./Template";
import { calculateAge, getToday } from "../services/utils";
import Autocomplete from '@material-ui/lab/Autocomplete';

// مادر و کودک
class SingleWorkshop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      InvalidFields: [],
      WorkshopType: [],
      KidFullName: "",
      BirthdayYear: "",
      BirthdayMonth: "",
      BirthdayDay: "",
      Age: "",
      Gender: "پسر",
      PhoneNumber: "",
      price: 0
    };
  }

  componentDidMount() {
    this.props.NextBtn(false);
  }


  DataHandler = () => {
    const { HandleData } = this.props;
    const {
      WorkshopType,
      KidFullName,
      BirthdayYear,
      BirthdayMonth,
      BirthdayDay,
      Age,
      Gender,
      PhoneNumber,
    } = this.state;
    HandleData({
      WorkshopType,
      KidFullName,
      BirthdayYear,
      BirthdayMonth,
      BirthdayDay,
      Age,
      Gender,
      PhoneNumber,
    }, 'step3')
  };

  $WorkShopTypes = [
    "خلاقیت",
    "فستیوال آب",
    "دقت و تمرکز",
    "نجار کوچولو",
    "فستیوال رنگ",
    "مسی پلی"
  ];

  NextBtnActivator = () => {
    this.props.NextBtn(
      this.state.InvalidFields.length === 0 && this.state.WorkshopType.length > 0
    );
  }

  // noinspection DuplicatedCode
  ValidateField = e => {
    const INVALID_FIELDS = this.state.InvalidFields;
    if (e.target.value === "" || e.target.value === 0 || e.target.value === []) {
      INVALID_FIELDS.push(e.target.name);
    } else if (INVALID_FIELDS.includes(e.target.name)) {
      const NAME = e.target.name;
      const INDEX = INVALID_FIELDS.indexOf(NAME);
      INVALID_FIELDS.splice(INDEX, 1);
    }
    this.setState({
      InvalidFields: INVALID_FIELDS
    });

    this.NextBtnActivator();
  }

  Require = (FieldName) => {
    return {
      onBlur: this.ValidateField,
      error: this.state.InvalidFields.includes(FieldName)
    }
  }

  ChangeHandler = (e) => this.setState({ [e.target.name]: e.target.value }, this.DataHandler);

  CalculateAge = () => {
    const { BirthdayYear, BirthdayMonth, BirthdayDay } = this.state;
    if ((BirthdayYear !== 0 && BirthdayMonth !== 0 && BirthdayDay !== 0)) {
      if (BirthdayYear < getToday().year && BirthdayYear >= (getToday().year - 15)) {
        if (BirthdayMonth <= 12 && BirthdayMonth >= 1) {
          if (BirthdayDay >= 1 && BirthdayDay <= 31) {
            const age = calculateAge({ year: BirthdayYear, month: BirthdayMonth });
            if (age.month === 0)
              this.setState({ Age: `${age.year} سال ` });
            else
              this.setState({ Age: `${age.year} سال و ${age.month} ماه ` });
          } else this.setState({ Age: '' })
        } else this.setState({ Age: '' })
      } else if (
        this.state.InvalidFields.includes("BirthdayYear")
        || this.state.InvalidFields.includes("BirthdayMonth")
        || this.state.InvalidFields.includes("BirthdayDay")
      ) this.setState({ Age: 'لطفا تمامی فیلد های مربوط به تولد کودک را پر کنید' })
      else this.setState({ Age: 'سن کودک شما با سن تايین شده مطابقت ندارد' })
    } else {
      this.setState({ Age: `` })
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <FormTemplate>
            <TextField
              className="w-100"
              name="KidFullName"
              label="نام و نام خانوادگی کودک"
              defaultValue={this.state.KidFullName}
              onChange={this.ChangeHandler}
              variant={"outlined"}
              color="secondary"
              {...this.Require("KidFullName")}
            />
          </FormTemplate>
          <FormTemplate>
            <TextField
              className="w-100"
              name="PhoneNumber"
              label="شماره تماس"
              defaultValue={this.state.PhoneNumber}
              onChange={this.ChangeHandler}
              variant={"outlined"}
              color="secondary"
              {...this.Require("PhoneNumber")}
            />
          </FormTemplate>
          <FormTemplate>
            <Typography variant={'h6'} className={'font-weight-bold'}>
              جنسیت کودک :
            </Typography>
            <Select
              variant={'outlined'}
              name={"Gender"}
              value={this.state.Gender}
              color={"secondary"}
              onChange={this.ChangeHandler}
              className={"col-md-4 col-12 mr-0 mr-md-3"}
            >
              <MenuItem value={"پسر"}>پسر</MenuItem>
              <MenuItem value={"دختر"}>دختر</MenuItem>
            </Select>
          </FormTemplate>
          <div className={"row mt-3"}>
            <div className="col-12">
              <Typography variant={"h6"} className={"font-weight-bold mb-2"}>
                تاریخ تولد کودک :
              </Typography>
            </div>
            <div className="col-3 m-auto">
              <TextField
                className="w-100"
                name="BirthdayYear"
                label="سال تولد"
                defaultValue={this.state.BirthdayYear}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                {...this.Require("BirthdayYear")}
              />
            </div>
            <div className="col-3 m-auto">
              <TextField
                className="w-100"
                name="BirthdayMonth"
                label="ماه تولد"
                defaultValue={this.state.BirthdayMonth}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                {...this.Require("BirthdayMonth")}
              />
            </div>
            <div className="col-3 m-auto">
              <TextField
                className="w-100"
                name="BirthdayDay"
                label="روز تولد"
                defaultValue={this.state.BirthdayDay}
                onChange={this.ChangeHandler}
                variant={"outlined"}
                color="secondary"
                onBlur={e => {
                  this.ValidateField(e);
                  this.CalculateAge();
                }}
                error={this.state.InvalidFields.includes("BirthdayDay")}
              />
            </div>
          </div>
          <FormTemplate>
            <TextField
              className="w-100"
              name="Age"
              label="سن کودک"
              value={this.state.Age}
              onChange={this.ChangeHandler}
              variant={"outlined"}
              color="secondary"
              disabled={true}
              {...this.Require("Age")}
            />
          </FormTemplate>
          <FormTemplate>
            <Autocomplete
              multiple
              id="tags-standard"
              options={this.$WorkShopTypes}
              getOptionLabel={(option) => option}
              value={this.state.WorkshopType}
              onChange={(e, v) => {
                this.setState({ WorkshopType: v ,  price: this.props.ModeData('1').price * v.length}, this.DataHandler);
                this.NextBtnActivator();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="انتخاب کارگاه"
                  color={"secondary"}
                  name={"WorkshopType"}
                  error={this.state.InvalidFields.includes("WorkshopType")}
                // placeholder="انتخاب کارگاه"
                />
              )}
            />
          </FormTemplate>

          <div className="row">
            <div className="col-12 text-center p-5">
              {!this.state.price ? <></> : <>
                <Typography align='center' className='font-weight-bold' variant="h5">
                مبلغ قابل پرداخت 
              </Typography>
              <Typography align='center' className='font-weight-bold text-success pt-2' variant="h5">
                {this.state.price}T
              </Typography>
              </>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SingleWorkshop;
